import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { DefaultImageLarge, DefaultImageSmall } from '../img';

import STYLES from './AlternativeImage.module.scss';

type Props = {
  className?: string;
  large?: boolean;
  alt?: string;
  width?: number | undefined;
  height?: number | undefined;
};

const cls = cssModules(STYLES);

const AlternativeImage = ({ alt, className, large = true, ...rest }: Props) => (
  <img
    src={large ? DefaultImageLarge : DefaultImageSmall}
    className={cls('AlternativeImage', className)}
    alt={alt}
    data-testid="alternative-image"
    {...rest}
  />
);

export default AlternativeImage;
